"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTotalPublicProvider = void 0;
var react_1 = __importDefault(require("react"));
var QuoteTotalContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteTotal/QuoteTotalContext");
var useMobxEject_1 = require("@CommonFrontend/hooks/useMobxEject");
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var QuoteTotalPublicProvider = function (_a) {
    var total = _a.total, initialPrice = _a.price, initialPriceSummary = _a.priceSummary, blockId = _a.blockId, di = _a.di, children = _a.children;
    var price = (0, useMobxEject_1.useMobxEject)(function () {
        var quoteSummaryStore = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore");
        if (!quoteSummaryStore)
            return initialPrice;
        return (0, Helpers_1.getPriceSummaryTotalForItem)(quoteSummaryStore.priceSummary, total.totalFor === "block" ? blockId : undefined);
    }, [blockId, di, initialPrice, total.totalFor]);
    var allDiscounts = (0, useMobxEject_1.useMobxEject)(function () {
        var quoteSummaryStore = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore");
        var priceSummary = quoteSummaryStore ? quoteSummaryStore.priceSummary : initialPriceSummary;
        (0, tiny_invariant_1.default)(!!priceSummary, "priceSummary wasn't available from DI or intial data");
        var totalPriceSummary = total.totalFor === "block"
            ? (0, Helpers_1.getPriceSummaryForItem)(priceSummary, "block", blockId)
            : (0, Helpers_1.getPriceSummaryForItem)(priceSummary, "page");
        return (0, Helpers_1.collectDiscounts)(totalPriceSummary);
    }, [blockId, di, initialPriceSummary, total.totalFor]);
    return (react_1.default.createElement(QuoteTotalContext_1.QuoteTotalProvider, { value: {
            components: {},
            total: total,
            price: price,
            allDiscounts: allDiscounts,
        } }, children));
};
exports.QuoteTotalPublicProvider = QuoteTotalPublicProvider;
